import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricParticipationPercentRate extends MetricBase {
    constructor() {
        super({
            field: "metric_participation_percent",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.participationPercentRate.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.participationPercentRate.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.participationPercentRate.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricParticipationPercentRate;
